/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AuditLogTypeFromJSON, AuditLogTypeToJSON } from './';
export function AuditLogsSearchFromJSON(json) {
    return AuditLogsSearchFromJSONTyped(json, false);
}
export function AuditLogsSearchFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        userId: !exists(json, 'userId') ? undefined : json['userId'],
        userEmail: !exists(json, 'userEmail') ? undefined : json['userEmail'],
        type: !exists(json, 'type') ? undefined : AuditLogTypeFromJSON(json['type']),
        after: !exists(json, 'after') ? undefined : new Date(json['after']),
        before: !exists(json, 'before') ? undefined : new Date(json['before']),
        pageSize: !exists(json, 'pageSize') ? undefined : json['pageSize'],
        pageIndex: !exists(json, 'pageIndex') ? undefined : json['pageIndex'],
    };
}
export function AuditLogsSearchToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        userId: value.userId,
        userEmail: value.userEmail,
        type: AuditLogTypeToJSON(value.type),
        after: value.after === undefined ? undefined : value.after.toISOString(),
        before: value.before === undefined ? undefined : value.before.toISOString(),
        pageSize: value.pageSize,
        pageIndex: value.pageIndex,
    };
}
